export enum RouteState {
  CREATED = 'CREATED',
  ON_BOARDING = 'ON_BOARDING',
  PROCESSING = 'PROCESSING',
  CANCELLED = 'CANCELLED',
  RESET = 'RESET'
}

export enum RouteTaskState {
  CANCELED = 'CANCELED',
  RESET = 'RESET',
  FINISHED = 'FINISHED',
  PROCESSING = 'PROCESSING',
  RE_ALLOCATED = 'RE_ALLOCATED',
  ON_BOARDED = 'ON_BOARDED',
  RESCHEDULED = 'RESCHEDULED'
}

export enum RouteTaskStateV2 {
  CANCELLED = 'CANCELLED',
  RESET = 'RESET',
  FINISHED = 'FINISHED',
  PROCESSING = 'PROCESSING',
  RE_ALLOCATED = 'RE_ALLOCATED',
  ON_BOARDED = 'ON_BOARDED',
  RESCHEDULED = 'RESCHEDULED'
}
